import { render, staticRenderFns } from "./user_center_buy.vue?vue&type=template&id=10b0dae4&scoped=true"
import script from "./user_center_buy.vue?vue&type=script&lang=js"
export * from "./user_center_buy.vue?vue&type=script&lang=js"
import style0 from "./user_center_buy.css?vue&type=style&index=0&id=10b0dae4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0dae4",
  null
  
)

export default component.exports